import Vue from 'vue'
import Router from 'vue-router'

Vue.use(Router)

function view (v) {
  return () => import(`@/views/${v}`)
}

export default new Router({
  // mode: 'history',
  base: process.env.BASE_URL,
  routes: [
    { name: 'home', path: '/', component: view('Home') },
    { name: 'login', path: '/login', component: view('Auth/Login') },
    { name: 'logout', path: '/logout', component: view('Auth/Logout') },
    { name: 'travelanium', path: '/travelanium', component: view('Travelanium/Index') },
    { name: 'hotellink', path: '/hotellink', component: view('Hotellink/Index') },

    { name: 'google-ads', path: '/google/ads/', component: view('Google/Ads/Index') },
    { name: 'google-ads-campaign', path: '/google/ads/:customer/campaign', component: view('Google/Ads/Campaign') },
    { name: 'google-ads-ad-group', path: '/google/ads/:customer/:campaign/adgroup', component: view('Google/Ads/AdGroup') },
    { name: 'google-ads-ad-group-ad', path: '/google/ads/:customer/:campaign/:adgroup/ad', component: view('Google/Ads/AdGroupAd') },
    { name: 'google-ads-ad-group-keyword', path: '/google/ads/:customer/:campaign/:adgroup/keyword', component: view('Google/Ads/AdGroupKeyword') }
  ]
})
